import { render, staticRenderFns } from "./CandidateReservedInfo.vue?vue&type=template&id=38ad14d5&scoped=true&lang=pug&"
import script from "./CandidateReservedInfo.vue?vue&type=script&lang=js&"
export * from "./CandidateReservedInfo.vue?vue&type=script&lang=js&"
import style0 from "./CandidateReservedInfo.vue?vue&type=style&index=0&id=38ad14d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad14d5",
  null
  
)

export default component.exports